import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";

interface HeaderState {
  scrollTop: number;
  transparentHeader: boolean;
  isProfileMenuIconVisible: boolean;
  isNavBarVisible: boolean;
  isLogoClickable: boolean;
  isOnATransparentHeaderPage: boolean;
  shouldHideOnScroll: boolean;
  scrollDirection: number;
  disabledHeader: boolean;
}

interface HeaderActions {
  setScrollTop: (scrollTop: number) => void;
  setTransparentHeader: (transparentHeader: boolean) => void;
  setIsProfileMenuIconVisible: (isProfileMenuIconVisible: boolean) => void;
  setIsNavBarVisible: (isNavBarVisible: boolean) => void;
  setIsLogoClickable: (isLogoClickable: boolean) => void;
  setShouldHideOnScroll: (shouldHideOnScroll: boolean) => void;
  setIsOnATransparentHeaderPage: (isOnATransparentHeaderPage: boolean) => void;
  setScrollDirection: (scrollDirection: number) => void;
  setDisabledHeader: (disabledHeader: boolean) => void;
  resetHeader: () => void;
}

export const initialState: HeaderState = {
  scrollTop: 0,
  transparentHeader: false,
  isProfileMenuIconVisible: true,
  isNavBarVisible: true,
  isLogoClickable: true,
  isOnATransparentHeaderPage: false,
  shouldHideOnScroll: true,
  scrollDirection: 0,
  disabledHeader: false,
};

export const useHeaderStore = createWithEqualityFn<HeaderState & HeaderActions>()(
  (set) => ({
    ...initialState,
    setScrollTop: (scrollTop: number) => set({ scrollTop }),
    setTransparentHeader: (transparentHeader: boolean) => set({ transparentHeader }),
    setIsProfileMenuIconVisible: (isProfileMenuIconVisible: boolean) =>
      set({ isProfileMenuIconVisible }),
    setIsNavBarVisible: (isNavBarVisible: boolean) => set({ isNavBarVisible }),
    setIsLogoClickable: (isLogoClickable: boolean) => set({ isLogoClickable }),
    setShouldHideOnScroll: (shouldHideOnScroll: boolean) => set({ shouldHideOnScroll }),
    setIsOnATransparentHeaderPage: (isOnATransparentHeaderPage: boolean) =>
      set({ isOnATransparentHeaderPage }),
    setScrollDirection: (scrollDirection: number) => set({ scrollDirection }),
    setDisabledHeader: (disabledHeader: boolean) => set({ disabledHeader }),
    resetHeader: () => set({ ...initialState }),
  }),
  shallow
);
